import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import { Avatar, ReviewRating, UserDisplayName } from '../../components';

import css from './Reviews.module.css';

const Review = props => {
  const { review, intl } = props;

  const date = review.attributes.createdAt;
  const dateString = intl.formatDate(date, { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <>
    <div className={css.review}>
      <Avatar className={css.avatar} user={review.author} />
      <div>
        <div className={css.reviewInfo}>
          <UserDisplayName className={css.reviewAuthorName} user={review.author} intl={intl} />
          <div className={css.desktopReviewRatingWrapper}>
            <ReviewRating
              rating={review.attributes.rating}
              className={css.desktopReviewRating}
              reviewStarClassName={css.reviewRatingStar}
            />
            <ReviewRating
              rating={review.attributes.rating}
              className={css.mobileReviewRating}
              reviewStarClassName={css.reviewRatingStar}
            />
          </div>
          <div className={css.reviewDate}>{dateString}</div>
        </div>
      </div>
    </div>
    <p className={css.reviewContent}>{review.attributes.content}</p>
    </>
  );
};

/**
 * A component that renders a list of reviews.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {Array<propTypes.review>} props.reviews - The reviews to render
 * @returns {JSX.Element}
 */
const Reviews = props => {
  const intl = useIntl();
  const { className, rootClassName, reviews = [] } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <ul className={classes}>
      {reviews.map(r => {
        return (
          <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
            <Review review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  );
};

export default Reviews;
